import { render, staticRenderFns } from "./PostVideo.vue?vue&type=template&id=39c9a2da&scoped=true&"
import script from "./PostVideo.vue?vue&type=script&lang=js&"
export * from "./PostVideo.vue?vue&type=script&lang=js&"
import style0 from "./PostVideo.vue?vue&type=style&index=0&id=39c9a2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c9a2da",
  null
  
)

/* custom blocks */
import block0 from "./PostVideo.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports